import queryProvider from 'servicestack/query-provider';
import apiConfig from 'servicestack/config.directive';
import $appConfig from 'servicestack/config';
import $session from 'servicestack/session';

export const dependencies = [];
export const directives = {
    apiConfig,
    appConfig: apiConfig,
    serviceBusConfig: apiConfig,
    queryProvider,
}

export default {
    dependencies,
    directives,
    runners: {
        servistackScope($rootScope) {
            Object.assign($rootScope, { $session, $appConfig });
        }
    }
};
